module.exports = __webpack_public_path__ + "static/media/path.627296ae.svg";